<template>
  <div>
    <div class="print-header"><img src="@/assets/img/common/logo-color-set.svg" alt=""></div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      isAdmin: false,
    }
  },
  created: async function() {
    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isAdmin = authority.isAdmin;
  },
  destroyed() {
  }
}
</script>
